import { useCallback, useEffect, useState } from 'react';

/** Same key Dashboard has always used, so both pages share one favorites list. */
export const favoritesKey = (email) => `rtg_favorites_${email || 'anon'}`;

function read(email) {
  try {
    const raw = localStorage.getItem(favoritesKey(email));
    const ids = raw ? JSON.parse(raw) : [];
    return Array.isArray(ids) ? ids : [];
  } catch {
    return [];
  }
}

function write(email, ids) {
  try {
    localStorage.setItem(favoritesKey(email), JSON.stringify(ids));
  } catch {
    /* storage unavailable (private window) -- favorites just won't persist */
  }
}

export function useFavorites(email) {
  const [favoriteIds, setFavoriteIds] = useState(() => (email ? read(email) : []));

  useEffect(() => { if (email) setFavoriteIds(read(email)); }, [email]);

  const toggleFavorite = useCallback((id) => {
    setFavoriteIds((prev) => {
      const next = prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id];
      write(email, next);
      return next;
    });
  }, [email]);

  return { favoriteIds, toggleFavorite };
}
